import * as Yup from 'yup'

export const validationSchema = (t) =>
  Yup.object().shape({
    route: Yup.object().nullable().required(t('form.required')),
    pickupPoint: Yup.object().nullable().required(t('form.required')),
  })
